<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fill-rule="evenodd"
				clip-rule="evenodd"
				d="M19.76 3.81147C18.8447 2.89618 17.3607 2.89618 16.4454 3.81147L5.05037 15.2066C3.52488 16.7321 3.52488 19.2054 5.05036 20.7309C6.57585 22.2564 9.04915 22.2564 10.5746 20.7309L18.5882 12.7173C18.8933 12.4122 19.3879 12.4122 19.693 12.7173C19.9981 13.0224 19.9981 13.5171 19.693 13.8222L11.6795 21.8357C9.54381 23.9714 6.08119 23.9714 3.94551 21.8357C1.80983 19.7001 1.80983 16.2374 3.94551 14.1018L15.3406 2.70661C16.8661 1.18113 19.3394 1.18113 20.8648 2.70661C22.3903 4.2321 22.3903 6.7054 20.8648 8.23088L9.4764 19.6193C9.47346 19.6223 9.47049 19.6253 9.46748 19.6283L9.46033 19.6354L9.45803 19.6377L9.45569 19.64C8.53921 20.5413 7.06582 20.5366 6.15522 19.626C5.23993 18.7107 5.23993 17.2268 6.15521 16.3115L14.2911 8.17534C14.5962 7.87024 15.0909 7.87023 15.396 8.17533C15.7011 8.48042 15.7011 8.97508 15.396 9.28018L7.26008 17.4163C6.95498 17.7214 6.95498 18.2161 7.26007 18.5212C7.56293 18.824 8.05267 18.8262 8.35816 18.5279L19.76 7.12603C20.6753 6.21074 20.6753 4.72676 19.76 3.81147Z"
				:fill="color"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgClip',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
